<div class="flex-column f-1-0" >
	<!--reviewers table-->
	<trustifi-table-c
		class="trustifi-table" style="flex: 1 0; z-index: 5; overflow: auto;"
		[list]="reviewers"
		[headers]="[
				{text:'Reviewer', sortKey:'email'},
				{text:'View Content', sortKey:'allow_view_content', tooltip: 'Allow reviewer to view the email content for archived emails'},
				{text:'Trends and Insights', sortKey:'allow_trends_page', tooltip: 'Allow reviewer to access the Trends and Insights page'},
			]"
		[cellsPrototype]="[
				{textKey: 'email', edit: {modelKey: 'email', placeholder: 'Reviewer email'}},
				{html: 'viewContentCell'},
				{html: 'trendsCell'},
			]"
		[bulkActions]="{
				enable: true,
				selectBulkActionCb:	selectMultipleReviewerAction,
				initBulkActionsFunction: showReviewerBulkActions,
				showInRed: {enable: true, terms: ['Remove']}
			}"
		[cellActions] = "{
				enable: true,
				selectItemActionCb:	selectReviewerAction,
				initActionsFunction: showReviewerActions,
				showInRed: {enable: true, terms: ['Remove']}
			}"
		(searchFunction)="searchReviewer($event.searchTerm, $event.activeFilters)"
		(confirmEditFunction)="confirmAddReviewer($event.item, $event.isApproved)"
		[options]="{
				itemsNameSingular: 'reviewer',
				defaultSortKey: '-email',
			}"
	>
		<ng-template #customCells let-item let-cellId="cellId">
			<!--action cells-->
			<div *ngIf="cellId === 'viewContentCell'">
				<span [ngStyle]="{color: item.allow_view_content || item.isNew ? 'green' : 'red'}">{{item.allow_view_content || item.isNew ? 'Enabled' : 'Disabled'}}</span>
			</div>
			<div *ngIf="cellId === 'trendsCell'">
				<span [ngStyle]="{color: item.allow_trends_page || item.isNew ? 'green' : 'red'}">{{item.allow_trends_page || item.isNew ? 'Enabled' : 'Disabled'}}</span>
			</div>
		</ng-template>
		<div tableButtons>
			<div class="btn-with-dropdown">
				<btn-c (action)="startAddReviewer();"
					   endIcon="far fa-plus"
					   [isDisabled]="addReviewerInProcess">
					Add Reviewer
				</btn-c>
				<app-dropdown-c [isLf]="true">
					<li (click)="openUsersSelection()">
						Add from my users
					</li>
				</app-dropdown-c>
			</div>
		</div>
	</trustifi-table-c>
</div>

<users-selection-component
	*ngIf="usersSelectionPopup?.show"
	[data]="usersSelectionPopup"
	[selectedUsers]="selectedUsers"
	(addCb)="addExistUsersToReviewers($event.users)"
	(removeCb)="startRemoveFromUsersSelection($event.users)">
</users-selection-component>

<popup-c *ngIf="reviewerPermissionPopup?.show"
         head="Modify Permissions"
         class="bs-enabled"
         subTitle="Configure permissions for {{reviewerPermissionPopup.reviewerObj.email}}"
         (closeCb)="reviewerPermissionPopup = null;"
         size="dynamic">

	<div class="flxClmn gap-4">
		<div class="flxRow">
			<div class="flxClmn gap-1" style="width: 450px;">
				<b>View Content</b>
				<span>Allow reviewer to view the email content for archived emails</span>
			</div>
			<div class="content-container flex-column gap-3">
				<toggle-switch-c id="allow_view_content"
				                 [hideText]="true"
				                 [(model)]="reviewerPermissionPopup.reviewerObj.allow_view_content"
				                 (onChange)="reviewerPermissionExecute(reviewerPermissionPopup.reviewerObj, 'allow_view_content')"></toggle-switch-c>
			</div>
		</div>

		<div class="flxRow">
			<div class="flxClmn gap-1" style="width: 450px;">
				<b>Trends and Insights</b>
				<span>Allow reviewer to access the Trends and Insights page</span>
			</div>
			<div class="content-container flex-column gap-3">
				<toggle-switch-c id="allow_trends_page"
				                 [hideText]="true"
				                 [(model)]="reviewerPermissionPopup.reviewerObj.allow_trends_page"
				                 (onChange)="reviewerPermissionExecute(reviewerPermissionPopup.reviewerObj, 'allow_trends_page')"></toggle-switch-c>
			</div>
		</div>

	</div>
</popup-c>
